import { Stack, styled } from "@/theme/index";

export const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.palette.background.paper,
  width: "100%",
  padding: theme.spacing(2),
  zIndex: 10,
}));
